
<div class="player-list-view">
  <ftu-block
    dismiss-key="players"
    icon="sports_handball"
    title="These are players"
    description="The players below are indexes that track the aggregate daily value movements of all verified cards of that player. Use these indexes to research specific player markets within the hobby to gauge where the markets are moving."
  />

  <page-header title="Players" />

  <align flex collapse-end direction="flex-start">
    <shared-filters
      show-recent-searches
      :filters.sync="filters"
      :query.sync="query"
      :properties="defaultFilters"
      @clear="clearFilters"
    />

    <direction-sort-options
      :sort.sync="sort"
      :direction.sync="direction"
      :options="sortOptions"
    />
  </align>

  <filter-results
    :is-filtering="isFiltering"
    :filters="filters"
    :results="numResults && numResults < 10000 ? numResults : null"
    @clear="clearFilters"
  />

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="search_off"
      title="There are no results for your search"
      description="Try adjusting your search"
    />

    <template v-else-if="loaded">
      <div class="list">
        <index-list-item
          v-for="player in players"
          :key="player.player"
          :to="`/players/${player.player}`"
          :index="player"
          :fields="statFields"
          as="router-link"
        />
      </div>

      <infinite-scroll
        :loading="loading"
        :has-more-data="hasMoreData"
        @load="nextPage"
      />
    </template>

    <spinner v-else />
  </div>

  <scroll-top />
</div>
